import styled from 'styled-components';
import { Container as OperationsListContainer } from '../OperationsList/OperationsList.styles';
import {
  Item as OperationListItem,
  Content,
  TopRow,
  BottomRow,
} from '../OperationListItem/OperationListItem.styles';

export const Container = OperationsListContainer;

export const Item = styled(OperationListItem)`
  cursor: default;
`;

export { Content, TopRow, BottomRow };
